<app-common-usecase-hero [heroData]="heroHeader"></app-common-usecase-hero>
<app-common-companies-panel
  [companiesData]="logosData"
></app-common-companies-panel>
<app-common-subproducts-alternate-blocks
  [featureData]="featureData1"
  [isInside]="true"
  [multicolor]="true"
  [bgColorData]="['moonstone-100', 'pink-100', 'blue-100', 'grey-100']"
></app-common-subproducts-alternate-blocks>
<app-enterprise-casestudy></app-enterprise-casestudy>
<app-enterprise-other-features></app-enterprise-other-features>
<app-common-subproducts-whitepaper
  [whitePaperData]="whitePaperData"
></app-common-subproducts-whitepaper>
<app-enterprise-helping-business></app-enterprise-helping-business>
<app-enterprise-api-content></app-enterprise-api-content>
<app-common-getstarted
  [getStartedData]="getStartedData"
></app-common-getstarted>
